import { defineStore } from 'pinia'

export interface TransactionUserInfo
{
  memberId: string
  nickName: string
}

// 交易记录信息
export const useTransactionHistoryStore = defineStore(
  'transactionHistory',
  () => {
    const transactionUserInfo = ref<TransactionUserInfo>({
      memberId: '',
      nickName: '',
    })
    // 设置信息
    function setUserInfo(val: TransactionUserInfo) {
      transactionUserInfo.value = val
    }

    // 删除信息
    function removesUserInfo() {
      transactionUserInfo.value.memberId = ''
      transactionUserInfo.value.nickName = ''
    }

    return {
      transactionUserInfo,
      setUserInfo,
      removesUserInfo,
    }
  },
)
